export const ButtonLoader = () => {
    return (
        <div
            className="spinner-loader"
            style={{display:"flex", margin:"auto"}}
        ></div>
    )
}